import { render, staticRenderFns } from "./editArea.vue?vue&type=template&id=199ced2a&scoped=true&"
import script from "./editArea.vue?vue&type=script&lang=js&"
export * from "./editArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ced2a",
  null
  
)

export default component.exports